<template lang="pug">
  v-flex#finished-loans(xs12 sm12 md12 lg12)
    //- CONFIRM TRANSACTION
    v-layout(row wrap justify-center)
      v-flex(xs12 sm12 md6 lg6)
        v-layout(row wrap justify-center)
          v-flex.main-icon(xs12 sm12 md12 lg12)
            img(:src="icons.star" alt="transaction-confirm")
          v-flex.main-title(xs12 sm12 md12 lg12)
            h2.mb-2.omnesMedium ¡Tu préstamo ha sido aprobado!
          //- v-flex(xs12 sm12 md12 lg12 v-if="$vuetify.breakpoint.mdAndUp")
          v-flex(xs12 sm12 md12 lg8)
            v-layout(row wrap justify-center)
              v-flex.details(xs4)
                img(:src="icons.aboutLoan" alt="about-loan")
                h4.mb-2.omnesMedium Monto:
                h5 {{ amount }}
              v-flex.details(xs4)
                img(:src="icons.numberAccount" alt="number-account")
                h4.mb-2.omnesMedium Cuenta:
                h5 {{ numberAccount }}
              v-flex.details(xs4)
                img(:src="icons.bank" alt="bank")
                h4.mb-2.omnesMedium Banco:
                h5 {{ bank }}
          //- v-flex.parraf(xs12 sm12 md12 lg12)
          //-   h4.mt-3.info--text El abono se realizará en máximo 72 horas hábiles
        v-layout(row wrap justify-center)
          v-flex.btn-action(xs12 sm12 md12 lg6)
            v-btn#finish-loans.my-4(color="dark" @click="finishTransact") Entendido
        v-layout(row wrap justify-center)
          v-flex.parraf-2.mt-2(xs12 sm12 md12 lg6)
            h3.omnesMedium
              | ¿Cómo es el proceso de
              br
              | desembolso de mi préstamo?
        v-layout(row wrap justify-center)
          v-flex(xs12)
            v-layout(row wrap justify-center)
              v-flex(xs11 sm10 md8 lg7 xl5)
                v-stepper#finished-stepper(alt-labels)
                  v-stepper-header
                    v-stepper-step.first(step="1" complete) Recibimos tu solicitud
                    v-divider
                    v-stepper-step.second(step="2" color="dark") Hacemos el desembolso en 3 días hábiles
                    v-divider
                    v-stepper-step.third(step="3" color="dark") Realizamos el depósito
            v-flex(xs12 sm12 md1 lg1)
    v-layout.resumen-solicitud
      v-flex.mt-1(xs12)
        h4.omnesMedium.text-xs-center Solicitar el resumen de la solicitud a:
    //- v-layout.resumen-solicitud
      v-flex.text-xs-right(xs6)
        a(target="_blank" :href="`https://api.whatsapp.com/send?phone=51933559693&text=Hola`"  style="cursor:pointer;")
          img(:src="icons.whatsapp" alt="whatsapp"  style="cursor:pointer;")
      v-flex.text-xs-left(xs6)
        a(target="_blank" href="mailto:servicios@interseguro.com.pe?Subject=Consulta%20el%resumen%20de%20mi%20Préstamo" style="cursor:pointer;")
          img(:src="icons.email" alt="email"  style="cursor:pointer;")
</template>

<script>
import Functionalities from '../../interfaces/functionalities'
import {mapGetters} from 'vuex'

export default {
  props: ['amount', 'bank', 'numberAccount'],
  data () {
    return {
      onboarding: 0,
      steps: [
        { value: 1, text: 'Recibimos tu solicitud' },
        { value: 2, text: 'Hacemos el desembolso en menos de 3 días hábiles' },
        { value: 3, text: 'Realizamos el depósito' }
      ],
      icons: {
        star: require('./../../assets/loans/icon-star.svg'),
        aboutLoan: require('./../../assets/loans/icons/about-loans.svg'),
        numberAccount: require('./../../assets/loans/icons/number-account.svg'),
        bank: require('./../../assets/loans/icons/bank.svg'),
        whatsapp: require('./../../assets/loans/icons/whatsapp.svg'),
        email: require('./../../assets/loans/icons/email.svg')
      }
    }
  },
  methods: {
    finishTransact () {
      this.$router.push('/inicio')
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules'])
  },
  mounted () {
    const self = this
    if (!Functionalities.isAvailableSilent(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
      self.$router.push('/inicio')
      return
    }
      
    this.$gtm.trackEvent({
      "event":"content-view",
      "content-name":"/zona-segura/prestamos/paso/confirmacion",
      "content-view-name":"Préstamo cotizador - paso 4"
      })
    
 
  }
}
</script>

<style>
#finished-loans .main-icon,
#finished-loans .main-title,
#finished-loans .parraf,
#finished-loans .btn-action,
#finished-loans .details,
#finished-loans .parraf-2 {
  text-align: center;
}
#finished-loans .main-title,
#finished-loans .parraf {
  margin: 19px 0;
}
#finished-loans .parraf p, #finished-loans .parraf-2 p { margin-bottom: 0; }
#finished-loans .main-title h1 { font-weight: normal; }
#finished-loans .main-icon { margin-top: 3em; }
#finished-loans .main-icon img { width: 8rem; }
#finished-loans .details { line-height: 1; }
#finished-loans .details img {
  width: 25%;
  margin-bottom: 5px;
}
#finished-loans .details p { margin-bottom: 0; }

.v-stepper.v-stepper--alt-labels { box-shadow: none; }
.v-stepper.v-stepper--alt-labels .v-stepper__header .v-stepper__step--active .v-stepper__label { text-shadow: none; }
.v-stepper.v-stepper--alt-labels .v-stepper__header .v-stepper__step .v-stepper__label { text-align: center; }
/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  #finished-loans .main-icon { margin-top: 1.5em; }
  #finished-loans .main-icon img { width: 7rem; }
  #finished-loans .main-title { margin-bottom: 0; }
  #finished-loans .parraf { margin-top: 5px; }
  #finished-loans .main-title h1 { font-size: 20px; }
 */
  .v-stepper.v-stepper--alt-labels .v-stepper__header .v-stepper__step .v-stepper__label {
    display: block;
    font-size: 11px;
  }
  /* .v-stepper--alt-labels .v-stepper__step { flex-basis: 140px; } */
}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/LoansFinished.vue